'use client';

/** @jsxImportSource @emotion/react */
import dynamic from 'next/dynamic';

import { useStyles } from '@/components/HeaderTopSection/HeaderTopSection.styles';
import { HeaderTopSection } from '@/components/HeaderTopSection/HeaderTopSection';
import PlatformHeroBanner from './sections/platform-hero-banner/PlatformHeroBanner';
import { Header } from '@/components';

const Companies = dynamic(() => import('./sections/companies/Companies'));
const DigitalProduct = dynamic(() => import('./sections/digital-product/DigitalProduct'));
const WebPlatform = dynamic(() => import('./sections/web-platform/WebPlatform'));
const WebPlatformBringOrderSection = dynamic(
  () => import('./sections/web-platform-bring-order/WebPlatformBringOrder'),
);
const BackendPlatform = dynamic(() => import('./sections/backend-platform/BackendPlatform'));
const BackendBringOrderSection = dynamic(
  () => import('./sections/backend-bring-order/BackendBringOrder'),
);
const AIPlatform = dynamic(() => import('./sections/ai-platform/AIPlatform'));
const AIBringOrderSection = dynamic(() => import('./sections/ai-bring-order/AiBringOrder'));
const GetInTouch = dynamic(() => import('@/components/get-in-touch/GetInTouch'));
const Footer = dynamic(() => import('@/components/footer/Footer'));

const PlatformPage = () => {
  const styles = useStyles(false, false);
  return (
    <>
      <Header showNavbar={false} />
      <main>
        <PlatformHeroBanner />
        <Companies />
        <DigitalProduct />
        <WebPlatform />
        <WebPlatformBringOrderSection />
        <BackendPlatform />
        <BackendBringOrderSection />
        {/* <MobilePlatform /> */}
        <AIPlatform />
        <AIBringOrderSection />
        <GetInTouch />
      </main>
      <Footer />
    </>
  );
};

export default PlatformPage;
